import { render, staticRenderFns } from "./DatePicker.vue?vue&type=template&id=4dd9978d&"
import script from "./DatePicker.vue?vue&type=script&lang=js&"
export * from "./DatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/lib/jenkins/jobs/Applications/jobs/WebApps/jobs/dpr-field-calendar/workspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VDatePicker,VMenu,VTextField})
